import { useContext } from 'react';
import { Role } from '../../types/Role';
import { UserContext, hasAccess } from '../../context/UserProvider';

type AccessLevelProps = { role: Role; messageElement?: any; children: React.ReactNode };

export const AccessLevel = ({ role, messageElement, children }: AccessLevelProps) => {
    const { userRole } = useContext(UserContext);

    if (hasAccess(userRole, role)) {
        return <>{children}</>;
    }

    return messageElement ? messageElement : null;
};
